import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import useModalStore from "../StatesStore/ModalStore";
import { toast } from "react-toastify";
import { toastOptions } from "../lib/toastOptions";
function ConfirmModal() {
  const { title, data, closeModal } = useModalStore();
  console.log("data", data);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <Modal show centered onHide={closeModal}>
      <Modal.Body style={{ padding: isSmallScreen ? "1rem" : "2rem" }}>
        <div className="d-flex flex-column">
          <div className="d-flex w-100 justify-content-between">
            <div className="h4">{data?.titleContent}</div>
            <button
              type="button"
              className="d-flex align-items-center justify-content-center"
              style={{
                width: "22px",
                height: "22px",
                border: "1px solid red",
                borderRadius: "50%",
                color: "red",
                fontSize: "16px",
                fontWeight: "lighter",
                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                cursor: "pointer",
                backgroundColor: "white",
              }}
              onClick={closeModal}
            >
              x
            </button>
          </div>
          <p>{data?.content}</p>
        </div>
        <div className="d-flex flex-column gap-2 w-100 mt-3">
          <Button
            className="rounded-3"
            variant="danger"
            onClick={async () => {
              if (data?.type === "Unfriend") {
                await data?.yesFunction(data?.UID, data?.friendUID);
                data?.setActiveList(
                  data?.activeList.filter((id) => id !== data?.friendUID)
                );
                toast.success("User unfriend successfully!", toastOptions);
              } else if (data?.type === "Unfollow") {
                await data?.yesFunction(data?.UID, data?.friendUID);
                data?.setMyFollowinglist(
                  data?.myFollowingList.filter(
                    (user) => user.id !== data?.friendUID
                  )
                );
                toast.success("User unfollowed successfully!", toastOptions);
              } else {
                await data?.yesFunction();
              }
              closeModal();
            }}
          >
            {data?.buttonContent}
          </Button>
          <Button
            className="rounded-3"
            variant="primary-soft"
            onClick={closeModal}
          >
            Cancel
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ConfirmModal;
